module.exports = __webpack_public_path__ + "static/media/cropping_03.9ca2f975.png";